if(document.querySelector('.product-page__slider')) {
    new Swiper('.product-page__slider', {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 8,
        navigation: {
            nextEl: '.product-page__slider--next',
            prevEl: '.product-page__slider--prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 4,
                spaceBetween: 16
            },
            640: {
                slidesPerView: 3,
                spaceBetween: 16
            },
        },
    });
}

if(document.querySelector('.product-page__top--slider')) {
    new Swiper('.product-page__top--slider', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: '.swiper-pagination',
        },
    })
}
